import React, { useEffect, useRef, useState } from 'react'
import './reward-item-unclicked.styles.scss';
import { useDispatch, useSelector } from 'react-redux';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';

const RewardItemUnclicked = ({ 
    gameData,
    playerData,
    reward,
    handleRewardModalOpen 
}) => {

    const screenSize = useSelector(state => state.contentData.screenSize);
    const [ startingImage, setStartingImage ] = useState(null);
    const [ finishGif, setFinishGif ] = useState(null);
    const dispatch = useDispatch();
    const timeoutRef = useRef();

    useEffect(() => {
        return () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }
    }, [])

    useEffect(() => {
        if (!reward) return;
        setStartingImage(
            (reward.display === 'reward')
            ?
            '/images/icons/treasure2-cl.png'
            :
            (reward.display === 'achievement')
            ?
            '/images/icons/achievement2_cl.png'
            :
            (reward.display === 'prizepack')
            ?
            '/images/icons/prizepack2_cl.png'
            :
            ''
        )
        setFinishGif(
            (reward.display === 'reward')
            ?
            '/images/icons/treasure2.gif'
            :
            (reward.display === 'achievement')
            ?
            '/images/icons/achievement2_gif.gif'
            :
            (reward.display === 'prizepack')
            ?
            '/images/icons/prizepack2_gif.gif'
            :
            ''
        )
    }, [reward])

    return (
        <div className={`reward-item-unclicked ${screenSize}`}>
            <div 
                className='clickable-treasure' 
                id={`reward-${reward.id}-div`} 
                onClick={() => handleRewardModalOpen(reward.id)}>
                <ImageContainer 
                    alt='closed treasure icon' 
                    id={`reward-${reward.id}`} 
                    src={startingImage} />
            </div>
        </div>
    )
}

export default RewardItemUnclicked